import { FC, useState } from "react";
import { gameState } from "@/services/gameState";
import { GameProgress } from "@/models/gameState";
import { Box, IconButton } from "@mui/material";
import YoutubeInput from "./YoutubeInput";
import { YouTube } from "@mui/icons-material";

const RefereeTabletReplayControls: FC = () => {
  const gameProgress = gameState("gameProgress");

  const [youtubeInputOpen, setYoutubeInputOpen] = useState(false);

  if (gameProgress <= GameProgress.GAME_FINISHED) {
    return null;
  }

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        pb: 2,
      }}
    >
      <YoutubeInput
        open={youtubeInputOpen}
        onClose={() => setYoutubeInputOpen(false)}
      />

      <IconButton onClick={() => setYoutubeInputOpen(true)}>
        <YouTube sx={{ color: "#ed0135" }} />
      </IconButton>
    </Box>
  );
};

export default RefereeTabletReplayControls;
